import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetBonusesHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_BONUSES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetBonusesHistoryAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetBonusesHistory as SetGetBonusesHistory
}